<template>
  <el-dialog :title="title" :visible.sync="visible" width="70%" :close-on-click-modal="false">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="案例名称:" prop="title">
        <el-input type="text"  :maxlength="30" v-model="data.title" placeholder="请输入30字以内案例名称" clearable />
      </el-form-item>
      <el-form-item label="封面图:" prop="headPicUrl">
        <span class="tips-text">请上传3：2的封面案例图片</span>
        <FileUpload v-if="visible" v-model="fileObjsPic" :limit="1" :readOnly="false" @on-change="handleFileChange($event, 'pic')"  accept="image/gif,image/jpg,image/jpeg,image/png" :autoCropWidth="300" :autoCropHeight="200"></FileUpload>
      </el-form-item>
      <el-form-item label="排序:" prop="tenantSortNo">
        <el-input-number v-model="data.tenantSortNo" style="width: 100px" :min="0" :max="2147483647" :controls="false"></el-input-number>
        <span style="margin-left: 10px; color: #aba9a9;">注：数值小的排在前面</span>
      </el-form-item>
      <el-form-item class="uEditor" label="案例详情:" prop="content">
        <UEditor v-model="data.content"></UEditor>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { saveArticle } from "@/api/saas/package";
import UEditor from '@/components/UEditor'
import FileUpload from "@/components/CropperFileUpload/CropperFileUpload";

export default {
  name: "AddClueDialog",
  components: {
    UEditor,
    FileUpload
  },
  props: {
  },
  data() {
    return {
      title: '',
      introduction: null,
      visible: false,
      typeList: [{
          id: 1,
          name: '图文'
      },{
          id: 2,
          name: '视频'
      }],
      rules: {
        title: [
          {required: true, message: '请输入案例名称', trigger: 'change'}
        ],
        headPicUrl: [
          {required: true, message: '请上传案例封面图', trigger: 'change'}
        ],
        content: [
          {required: true, message: '案例详情不能为空', trigger: 'change'}
        ],
      },
      fileObjsPic: [],
      data: {
        title: null,
        content: null,
        contentType: 1,
        headPicUrl: null,
        tenantSortNo: undefined,
        articleType: 2
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible (val) {
      if (!val) {
        // 重置formData
        this.resetFormData()
      }
    }
  },
  methods: {
    resetFormData () {
      this.fileObjsPic = []
      this.resetForm("addForm");
      this.data.articleId = null
      this.data.title = null
      this.data.content = null
      this.data.contentType = 1
      this.data.headPicUrl = null
      this.data.tenantSortNo = undefined
    },
    open (row) {
      this.visible = true
      this.resetFormData()
      if(row){
        this.data = row
        this.title = '编辑案例'
        this.fileObjsPic = [{
          isImg: true,
          url: row.headPicUrl
        }]
        console.log('this.data', this.data)
      }else{
        this.title = '新增案例'
      }
    },
    handleFileChange (fileObjs, type) {
      if(fileObjs.length === 0) {
        this.fileObjsPic = []
        this.data.headPicUrl = ''
      }else {
        this.fileObjsPic = fileObjs
        this.data.headPicUrl = fileObjs[0].url
      }

    },
    confirm () {
      console.log('data', this.data)

      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          saveArticle(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            if(this.data.articleId){
              this.msgSuccess("编辑成功");
            }else {
              this.msgSuccess("添加成功");
            }
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
